import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc570c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "detailRegion mb-4" }
const _hoisted_3 = { class: "text-lg font-semibold mb-3" }
const _hoisted_4 = { class: "flex locationDetailRow" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "ID", -1))
const _hoisted_6 = { class: "flex locationDetailRow" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Text", -1))
const _hoisted_8 = { class: "flex locationDetailRow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Safety Instruction", -1))
const _hoisted_10 = { class: "flex locationDetailRow" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Date", -1))
const _hoisted_12 = { class: "flex locationDetailRow" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Type", -1))
const _hoisted_14 = { class: "flex locationDetailRow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Is New", -1))
const _hoisted_16 = { class: "flex locationDetailRow" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Has Description", -1))
const _hoisted_18 = { class: "flex locationDetailRow" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Parent Index", -1))
const _hoisted_20 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_21 = { class: "text-lg font-semibold mb-3" }
const _hoisted_22 = { class: "flex locationDetailRow" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Id", -1))
const _hoisted_24 = { class: "flex locationDetailRow" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Subscriber", -1))
const _hoisted_26 = { class: "flex locationDetailRow" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Producer", -1))
const _hoisted_28 = { class: "flex locationDetailRow" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Event Type", -1))
const _hoisted_30 = { class: "flex locationDetailRow" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Timestamp", -1))
const _hoisted_32 = { class: "flex locationDetailRow" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Attempt Count", -1))
const _hoisted_34 = { class: "flex locationDetailRow" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "State", -1))
const _hoisted_36 = { class: "mt-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium mb-1" }, "Payload", -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "flex locationDetailRow" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Registration Id", -1))
const _hoisted_41 = { class: "flex locationDetailRow" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Guest Count", -1))
const _hoisted_43 = { class: "flex locationDetailRow" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Registration Date", -1))
const _hoisted_45 = { class: "flex locationDetailRow" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Unregistration Date", -1))
const _hoisted_47 = { class: "flex locationDetailRow" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Contact Phone", -1))
const _hoisted_49 = { class: "flex locationDetailRow" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Activity", -1))
const _hoisted_51 = { class: "mt-2" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "User", -1))
const _hoisted_53 = { class: "flex locationDetailRow" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "User Id", -1))
const _hoisted_55 = { class: "flex locationDetailRow" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "User Name", -1))
const _hoisted_57 = { class: "flex locationDetailRow" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Email", -1))
const _hoisted_59 = { class: "mt-2" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Location", -1))
const _hoisted_61 = { class: "flex locationDetailRow" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Location Id", -1))
const _hoisted_63 = { class: "flex locationDetailRow" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Location Name", -1))
const _hoisted_65 = { class: "flex locationDetailRow" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailAttribute" }, "Phone", -1))
const _hoisted_67 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_68 = {
  key: 1,
  class: "text-sm text-gray-500"
}

import { toRef, computed } from 'vue';
    //import { useI18n } from "vue-i18n";
    import { $t } from "@/utilities/i18n/config";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationDetailPopup',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as { data: any }

    
    const popupData = toRef(props, 'data');
    //const { t } = useI18n();

    const root = computed(() => {

        const p = popupData.value ?? {};
        if (p.description && typeof p.description === 'object') {
            return p.description;
        }
        // If the top-level object already is the RootObject
        if (p.id !== undefined) return p;
        // best-effort return empty object
        return {};
    });

    const descriptionArray = computed(() => {
        try {
            const maybe = (root.value as any).description;
            if (!maybe) return [];
            if (Array.isArray(maybe)) return maybe;
            if (typeof maybe === 'string') return JSON.parse(maybe) as any[];
            if (typeof maybe === 'object') return maybe as any[];
            return [];
        } catch {
            return [];
        }
    });

    const parsedPayloads = computed(() =>
        descriptionArray.value.map((d: any) => {
            try {
                if (!d) return null;
                if (typeof d.PayloadJson === 'string') return JSON.parse(d.PayloadJson);
                return d.PayloadJson ?? null;
            } catch {
                return null;
            }
        })
    );

    function fmt(date?: string | null) {
        if (!date) return '-';
        const d = new Date(date);
        if (isNaN(d.getTime())) return date;
        return d.toLocaleString();
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref($t)('notifications.summery')), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, _toDisplayString(_unref(root).id ?? '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", null, _toDisplayString(_unref(root).text ?? '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", null, _toDisplayString(_unref(root).safetyInstruction ?? '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", null, _toDisplayString(fmt(_unref(root).date)), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", null, _toDisplayString(_unref(root).type ?? '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", null, _toDisplayString(_unref(root).isNew ? 'Yes' : 'No'), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", null, _toDisplayString(_unref(root).hasDescription ? 'Yes' : 'No'), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", null, _toDisplayString(_unref(root).parentIndex ?? '-'), 1)
      ])
    ]),
    (_unref(descriptionArray).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref($t)('notifications.description')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(descriptionArray), (desc, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: desc.Id,
              class: "mb-3 p-3 border rounded"
            }, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", null, _toDisplayString(desc.Id), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", null, _toDisplayString(desc.SubscriberName), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", null, _toDisplayString(desc.ProducerName), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", null, _toDisplayString(desc.EventType), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", null, _toDisplayString(fmt(desc.Timestamp)), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", null, _toDisplayString(desc.AttemptCount), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", null, _toDisplayString(desc.State), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                (_unref(parsedPayloads)[idx])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].registrationId ?? '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].guestCount ?? '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", null, _toDisplayString(fmt(_unref(parsedPayloads)[idx].registrationDate)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("div", null, _toDisplayString(fmt(_unref(parsedPayloads)[idx].unregistrationDate)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].contactPhoneNumber ?? '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].activityText ?? '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].user?.userId ?? '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].user?.userName ?? '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].user?.emailSender ?? '-'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].location?.locationId ?? '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].location?.locationName ?? '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("div", null, _toDisplayString(_unref(parsedPayloads)[idx].location?.phone ?? '-'), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_67, "Payload not available / invalid JSON"))
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_68, "No description items"))
  ]))
}
}

})